import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import connect from 'components/lib/connect';
import Toggle from 'components/common/toggle';
import ToggleDetailedDates from 'actions/agent_preferences/toggle_detailed_dates';
import useExecuteAction from 'components/hooks/use_execute_action';

export function AgentDetailedDatesToggle({ isEnabled }) {
  const executeAction = useExecuteAction();
  const { t } = useTranslation();

  const text = isEnabled
    ? t('Every message shows its full date and time')
    : t('Messages show relative timestamps and may be grouped');

  return (
    <Wrapper className="detailed-dates-toggle">
      <Toggle
        data-aid="detailedDatesToggle"
        isEnabled={isEnabled}
        onChange={() => executeAction(ToggleDetailedDates)}
      />
      <Text>{text}</Text>
    </Wrapper>
  );
}

AgentDetailedDatesToggle.propTypes = {
  isEnabled: PropTypes.bool.isRequired,
};

const AgentDetailedDatesToggleContainer = connect(mapStateToProps)(AgentDetailedDatesToggle);

function mapStateToProps({ getProvider }) {
  const preferences = getProvider('agentPreferences').get();

  return {
    isEnabled: preferences.detailedDatesEnabled,
  };
}

const Wrapper = styled.div`
  align-items: flex-start;
  display: flex;
`;

const Text = styled.span`
  /* Cap the width so the longer "off" copy wraps instead of widening (and re-centering) the whole profile. */
  margin-left: 8px;
  max-width: 240px;
`;

export default AgentDetailedDatesToggleContainer;
